import { useSelector } from "react-redux";
import './ConfirmationPage.scss'
import bgConfirmation from '../../images/AP/ap-bg-pageConfirmation.jpg'
import { isMobile } from "../../helpers/helpers";
import useBodyClass from "../../custom-Hooks/useBodyClass";
import useScrollTop from "../../custom-Hooks/useScrollTop";
import CONSTANTS from "../../Constants";
import { useEffect } from "react";
import { pushToGTMTracker } from "../../helpers/trackerManager";
const ConfiramtionPage = () => {
    const personalInfos = useSelector(state => state.ndel_store.personalInfos)
    const dealer = useSelector(state => state.ndel_store.dealer)
    useScrollTop()
    useBodyClass('confirmation-page')
    useEffect(()=>{
        pushToGTMTracker('confirmation-page', window.siteConfig.v2confirmation.Title.replace('[nom-marque]', CONSTANTS.SITE_INFO.BRAND_NAME.toUpperCase()), dealer)
    },[])
    return (
        <>
            <div className='page-title-block'>
                <h2 tabIndex='0' className='title'> {CONSTANTS.LABELS.confirm_title}</h2>
            </div>
            <div className='content-block'>
                <h4 tabIndex='0' className='content-title'>{CONSTANTS.LABELS.confirm_label1}</h4>
                <p tabIndex='0' className='first-line'>
                    {CONSTANTS.LABELS.confirm_quote_label1}
                </p>
                <p tabIndex='0' className='email'>
                    {personalInfos.email}
                </p>
                <p tabIndex='0' className='second-line'>
                    {CONSTANTS.LABELS.confirm_label3}
                </p>
            </div>

            {!isMobile() && <img className='bg-image' src={bgConfirmation} alt="confirmation" />}

        </>
    )
}
export default ConfiramtionPage;